// extracted by mini-css-extract-plugin
module.exports = {"card":"PasswordChangeUsed_card__3Tuq_","description":"PasswordChangeUsed_description__3e95X"};